<style lang="scss" scoped="scoped">
::-webkit-scrollbar {
  display: none;
}
</style>
<style lang="scss">

</style>
<template>
  <div style="display: flex;width: 100%;height: 473px;">
    <el-tabs tab-position="left">

      <el-tab-pane :label="$t('cangchutu')" style="padding: 0px 56px;">
        <div v-if="false" class="titleBar" style="display: flex;align-items:center ;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{$t('shifouxianshi')}}
          </p>
        </div>
        <div v-if="false" style="display: flex;align-items: center;margin-top: 12px;">
          <p>{{$t('xianshi')}}</p>
          <el-switch style="margin-left: 10px;" v-model="monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD"
              active-color="#419FFF">
          </el-switch>
        </div>
        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 0px;">
          <!-- <div class="titleBar" style="display: flex;align-items:center ;margin-top: 36px;"> -->
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{$t('shebeikapianyangshi')}}
          </p>
        </div>
        <div style="display: flex;align-items: center;margin-top: 12px;">
          <div style="display: flex;flex-direction: column;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="jianyue">{{$t('jianyue')}}
            </el-radio>
            <img style="width: 170px;height: 92px;margin-top: 12px;"
                src="../../../../assets/img/web/workshop/storage_jianyue.png"/>
          </div>
          <div style="display: flex;flex-direction: column;margin-left: 80px;">
            <el-radio v-model="monitorSetting.MONITOR_WORKSHOP_CARD_STYLE" label="tianchong">
              {{$t('tianchong')}}
            </el-radio>
            <img style="width: 170px;height: 92px;margin-top: 12px;"
                src="../../../../assets/img/web/workshop/storage_tianchong.png"/>
          </div>

        </div>

        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{$t('kapiankuandu')}}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;">
          <!-- <p>{{$t('meigekapiankuandu')}}</p> -->
          <el-input-number style="margin-left: 12px; " size="mini"
              v-model="monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH"></el-input-number>
          <p style="margin-left: 12px;">px</p>
        </div>

        <div class="titleBar" style="display: flex;align-items:center ;margin-top: 32px;">
          <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
          <p style="font-size: 16px;line-height: 22px;color: #303133;">
            {{$t('kapianziti')}}
          </p>
        </div>
        <div style="display: flex;align-items: center;padding-top: 14px;">
          <!-- <p>{{$t('kapianzitidaxiao')}}</p> -->
          <el-input-number style="margin-left: 12px;" size="mini"
              v-model="monitorSetting.MONITOR_WORKSHOP_CARD_FONT"></el-input-number>
          <p style="margin-left: 12px;">px</p>
        </div>

      </el-tab-pane>

    </el-tabs>

  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_store_chart_setting',
  components: {},

  data() {
    return {
      monitorSetting: {},
    };
  },
  created() {
    this.resetData()
  },
  activated() {
    this.resize()
  },
  mounted() {
    this.resize()
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
  },
  destroyed() {
  },
  methods: {
    resetData() {
      //可能要防到mainjs里面去初始化,因为看板拿配置的时候setting弹框还没打开
      let monitorSetting = localStorage.getItem("MONITOR_SETTING")
      if (!monitorSetting) {
        this.monitorSetting = {}
      } else {
        this.monitorSetting = JSON.parse(monitorSetting)
      }
      //每个单独初始化可以进行增量初始化，而不是一整个setting初始化
      this.monitorSetting.MONITOR_TEMPLATE = this.monitorSetting.MONITOR_TEMPLATE !=
      null ? this.monitorSetting.MONITOR_TEMPLATE : 'moren'
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD !=
      null ?
          this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_CARD : true
      this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE = this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE != null ?
          this.monitorSetting.MONITOR_WORKSHOP_CARD_STYLE : 'jianyue'
      this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH = this.monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH != null ?
          this
              .monitorSetting.MONITOR_WORKSHOP_CARD_WIDTH : 176
      this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT = this.monitorSetting.MONITOR_WORKSHOP_CARD_FONT != null ?
          this
              .monitorSetting.MONITOR_WORKSHOP_CARD_FONT : 14
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE !=
      null ?
          this
              .monitorSetting.IS_SHOW_MONITOR_WORKSHOP_OEE : true
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT = this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT !=
      null ?
          this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_ALERT : true
      this.monitorSetting.IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT = this.monitorSetting
          .IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT != null ? this.monitorSetting
          .IS_SHOW_MONITOR_WORKSHOP_HOUR_OUTPUT : true
      this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK = this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK != null ?
          this.monitorSetting.IS_MONITOR_WORKSHOP_BLACK : true


      this.monitorSetting.MONITOR_TEMPLATES = {
        "moren": [{
          "x": 0,
          "y": 0,
          "w": 8,
          "h": 6, //应该是6
          "i": "oee"
        },
          {
            "x": 8,
            "y": 0,
            "w": 12,
            "h": 6, //应该是6
            "i": "hour_output"
          },
          {
            "x": 20,
            "y": 0,
            "w": 4,
            "h": 24,
            "i": "alert"
          },
          {
            "x": 0,
            "y": 6,
            "w": 20,
            "h": 18, //应该是18
            "i": "card"
          },
        ],
        "shebeijiankong": [{
          "x": 0,
          "y": 6,
          "w": 24,
          "h": 24, //应该是18
          "i": "card"
        },],
      }
      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))

    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {

      }, 500)

    },
    save() {


      localStorage.setItem("MONITOR_SETTING", JSON.stringify(this.monitorSetting))
      this.utils.event_hub.$emit('SetLayout')
      this.utils.event_hub.$emit('SetCard')
    }

  }
};
</script>